import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { Template } from '../templates/template.model';
import { QCService } from './qc.service';

@Component({
  selector: 'app-qc-dashboard',
  templateUrl: './qc-dashboard.component.html',
  styleUrls: ['./qc-dashboard.component.scss']
})
export class QCDashboardComponent implements OnInit {

  archived: boolean = false;
  count: number = 0;
  loading: boolean = true;
  page: number = 1;
  paramsLoaded: boolean = false;
  subscription: Subscription;
  reports: Template[] = [];
  total: number = 0;

  get totalPages(): number {
    return Math.ceil(+this.total/10)
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private qcService: QCService) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.page = params.p != null ? +params.p : 1;
      this.archived = params.a == "true" ? true : false;
      this.loadReports();
      this.paramsLoaded = true;
    })
  }

  onArchivedChange(event) {
    if (!this.paramsLoaded) { return }
    let checked = event.value;
    this.archived = checked ? true : false;
    this.page = 1;
    this.updateRoute();
  }

  loadReports() {
    this.loading = true;
    this.reports = [];
    this.count = 0;
    this.total = 0;
    if (this.subscription != null) {
      this.subscription.unsubscribe();
      this.subscription = null
    }
    this.subscription = this.qcService.getRecentReports(this.page, this.archived).subscribe(
      (data) => {
        this.reports = data.templates;
        this.count = data.templates.length;
        this.total = data.total;
        this.loading = false;
      },
      (errors) => {
        this.count = 0;
        this.total = 0;
        this.loading = false;
      }
    )
  }

  loadPage(page) {
    this.page = page;
    this.updateRoute();
  }

   updateRoute() {
    let query: any = {};
    if (this.page != 1) {query.p = this.page};
    if (this.archived) {query.a = "true"};
    this.router.navigate(["/qc_reports"], {queryParams: query})
  }

  wo_or_qc(report): string {
    let wo = report.data.disney_abc_wo_number;
    let qc = report.data.qc_number;
    if (wo == null || wo.trim() == '') {
      if (qc != null && qc.trim() != '') {
        return "QC # " + qc;
      } else {
        wo = "Unknown"
      }
    }
    return "WO # " + wo;
  }

  episode(report): string {
    let episode = [
      report.data.domestic_episode_number, 
      report.data.foreign_episode_number
    ].filter((x) => x != null && x.trim() != '')
    return episode.length > 0 ? episode.join('/') : null
  }

  format(report): string {
    let format = [
        report.data.format ?  report.data.format.displayed : null,
        report.data.standard ? report.data.standard.displayed : null
      ].filter((x) => x != null)
    return format.length > 0 ? format.join(' ') : null
  }

  operator(report): string {
    let operators = report.data.operators != null ? report.data.operators : []
    return operators.length > 0 ? operators.join(', ') : null
  }

}



// WEBPACK FOOTER //
// ./src/app/qc/qc-dashboard.component.ts